import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MainCanvasComponent } from './main-canvas/main-canvas.component';
import { xwareNavMainComponent } from './xware-nav-main/xware-nav-main.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { AngularMaterialModule } from '../angular.material.module';
import { CoreRoutingModule } from './core-routing.module';
import { XwareExpiredComponent } from '../admin/xware-expired/xware-expired.component';
import { XwareNavCmsComponent } from './xware-nav-main/xware-nav-cms/xware-nav-cms.component';

@NgModule({
  declarations: [
    MainCanvasComponent,
    xwareNavMainComponent,
    XwareNavCmsComponent,
    UserMenuComponent,
    XwareExpiredComponent,
  ],
  exports: [
    MainCanvasComponent,
    xwareNavMainComponent,
    XwareNavCmsComponent,
    UserMenuComponent,
    XwareExpiredComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AngularMaterialModule,
    CoreRoutingModule,
  ],
})
export class CoreModule {}
